import { useEffect, useState } from "react";
import {
  Form,
  useActionData,
  useLoaderData,
  useNavigate,
  useNavigation,
} from "react-router-dom";

import Resolver from "@/components/resolver";

import { Button, Link } from "@/components/clickable";
import { TextField } from "@/components/forms";
import { Grid, HStack, VStack } from "@/components/layout";
import { VerifyCodeFields } from "@/modules/auth";
import { PlanSelector } from "@/modules/billing";
import { getCheckoutPath } from "@/modules/onboarding";
import { isSubmitting } from "@/utils";
import Informations from "../informations";

export default function SignUpView() {
  const { prices } = useLoaderData();
  const navigate = useNavigate();
  const { state } = useNavigation();
  const [verifyCode, setVerifyCode] = useState(false);
  const data = useActionData();
  const formErrors = data?.formErrors || {};
  const error = data?.error || null;

  const handleVerifiedCode = () => {
    const searchParams = new URLSearchParams();
    if (data?.priceId) {
      searchParams.set("priceId", data.priceId);
    }
    if (data?.accountName) {
      searchParams.set("name", data.accountName);
    }
    navigate(getCheckoutPath(searchParams));
  };

  useEffect(() => {
    if (data?.email) {
      setVerifyCode(true);
    }
  }, [data]);

  return (
    <div className="custom-scrollbar text-cp-body max-h-dvh w-full overflow-auto lg:bg-zinc-100">
      <HStack className="isolate min-h-svh w-full items-center justify-center gap-10 overflow-auto p-8 max-lg:flex-col lg:gap-40">
        <Informations />
        <Form method="post">
          <VStack className="border-cp-grey-300 max-w-lg gap-4 rounded-md border bg-white p-10 shadow-lg">
            <p className="text-lg font-medium text-black">
              Create your CounselPro account
            </p>

            {verifyCode ? (
              <VerifyCodeFields
                email={data?.email}
                onCodeVerified={handleVerifiedCode}
                onReturn={() => setVerifyCode(false)}
              />
            ) : (
              <>
                <Resolver resolve={prices}>
                  <PlanSelector />
                </Resolver>

                <TextField
                  name="accountName"
                  error={formErrors.accountName}
                  label="Law firm name"
                  placeholder="Type the name of your firm"
                  description="This name will appear on your dashboard and in billing correspondence."
                />

                <Grid className="grid-cols-2 gap-4">
                  <TextField
                    name="firstName"
                    error={formErrors.firstName}
                    label="First name"
                    placeholder="Type your first name"
                  />
                  <TextField
                    name="lastName"
                    error={formErrors.lastName}
                    label="Last name"
                    placeholder="Type your last name"
                  />
                </Grid>

                <TextField
                  label="Email address"
                  name="email"
                  error={formErrors.email}
                  placeholder="Type your email address"
                  description="You will receive a 6-digit code to confirm your email address."
                />

                {error && (
                  <div className="mt-3">
                    <p className="text-xs font-semibold text-red-500">
                      Failed to submit SignUp form
                    </p>
                  </div>
                )}
                <Button
                  className="w-full"
                  color="green"
                  isLoading={isSubmitting(state)}
                  type="submit"
                >
                  Sign Up
                </Button>

                <p className="w-full text-center">
                  <Link className="text-sm" href="/login">
                    Already have an account?
                  </Link>
                </p>
              </>
            )}
          </VStack>
        </Form>
      </HStack>
    </div>
  );
}
